import {
  Box,
  type ButtonProps,
  CircularProgress,
  IconButton,
  type SxProps,
  type Theme,
  Tooltip,
} from '@mui/material';
import type { ReactNode } from 'react';

import { actionIconButtonStyles } from '../ActionIconButton';

interface Props {
  children: ReactNode;

  onClick?: () => void;
  href?: string;
  target?: string;

  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
  disabled?: boolean;
  loading?: boolean;
  tooltip?: string;
  /**
   * Render with the shared action-icon look (neutral bg + shadow + hover) used by
   * the row/toolbar action buttons. Opt-in so plain ActionButtons stay unstyled.
   */
  filled?: boolean;
  sx?: SxProps;
}

export default function ActionButton({
  children,
  onClick,
  href,
  target,
  color,
  size,
  disabled,
  loading,
  tooltip,
  filled,
  sx,
}: Props) {
  return (
    <Tooltip title={tooltip || ''}>
      <IconButton
        component={href ? 'a' : 'button'}
        onClick={onClick}
        href={href}
        disabled={disabled}
        sx={
          [
            ...(filled ? [actionIconButtonStyles] : []),
            ...(Array.isArray(sx) ? sx : [sx]),
          ] as SxProps<Theme>
        }
        target={target}
        color={color}
        size={size}
        loading={loading}
      >
        <Box
          sx={{
            display: 'flex',
            opacity: loading ? '0%' : '100%',
          }}
        >
          {children}
        </Box>
      </IconButton>
    </Tooltip>
  );
}
